import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PersistedAuthState {
  refreshToken: string | null;
  userId: number | string | null;
  shouldChangePassword: boolean;
  setRefreshToken: (token: string) => void;
  setUserId: (id: number | string) => void;
  setShouldChangePassword: (should: boolean) => void;
  clearPersistedAuth: () => void;
}

export const usePersistedAuthStore = create<PersistedAuthState>()(
  persist(
    (set) => ({
      refreshToken: null,
      userId: null,
      shouldChangePassword: false,

      setRefreshToken: (token: string) => {
        set({ refreshToken: token });
      },

      setUserId: (id: number | string) => {
        set({ userId: id });
      },

      setShouldChangePassword: (should: boolean) => {
        set({ shouldChangePassword: should });
      },

      clearPersistedAuth: () => {
        set({
          refreshToken: null,
          userId: null,
          shouldChangePassword: false,
        });
      },
    }),
    {
      name: 'persisted-auth-storage',
    }
  )
);